// HTML
export const LOADING_CONTAINER = 'loading-container';
export const NOTIFICATION_CONTAINER = 'stone-dop-notification';
export const FILTER_PILL_CONTAINER = 'stone-dop-filter-pill';
export const DEVICES_CONTAINER = 'stone-dop-devices';
export const TOTAL_DEVICES_CONTAINER = 'stone-dop-total-devices';
export const ACCORDION_CONTAINER = 'stone-dop-accordion';
